import { useEffect, useMemo, useRef, useState } from 'react';
import TimeZoneConverter from '../shared/timezone';
import { TextHighlighter } from '../shared/textBold';
import {
	useContractFilters,
	useFieldsFilters,
	useGlobalSearch,
	useContractChildFilters,
	useContractParentFilters,
    useSearchContract,
} from './hooks';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import LoaderFull from '../shared/loader-full-screen';
import { Autocomplete, TextField } from '@mui/material';
import { ContractDropdownOption } from './contractDropdown';
import dayjs from 'dayjs';
import DatePickerButton from './dateSelector';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { PAGE_SIZE_OPTIONS, sortDropdownOptions } from '../utils';

export const FilterContractList = ({ data, count, getpageSizeCall, setpageSizeCall, }) => {
	const [Count, setCount] = useState(count);
	const [searchParams, setSearchParams] = useSearchParams();
	const [invData, setInvData] = useState(data);
	const [page, setpage] = useState(1);
	const inv_data_hook = useGlobalSearch();
	const navigate = useNavigate();
	const getfilterHook = useContractParentFilters();
	const getChildFiltersHook = useContractChildFilters();
    const searchContractListHook = useSearchContract()
	const [selectedVendor, setSelectedVendor] = useState('');
	const [selectedCategory, setSelectedCategory] = useState('');
	const [selectedClient, setSelectedClient] = useState('');
	const [Filters, setFilters] = useState([]);
	const [childFilters, setChildFilters] = useState([]);
	const [contractFilters, setContractFilters] = useState([]);
	const [fields, setFields] = useState([]);
	const [pageSize, setPageSize] = useState(null);
	useEffect(() => {
		if (getfilterHook?.data) {
			setFilters(getfilterHook.data.data);
		}
	}, [getfilterHook?.data, getfilterHook?.isSuccess]);


	function keywordSearch(page = 1) {
		if (
			searchParams.get('keyword')?.trim() === '' ||
			searchParams.get('keyword') === null
		) {
			setInvData([]);
			return;
		}

		setInvData([]);
		let bd = {
			keyword: searchParams.get('keyword'),
			contract: true,
			contract_limit: pageSize,
			contract_page: page,
		};
		inv_data_hook.mutate(bd);
		
	}

	useEffect(() => {
		if (selectedCategory && selectedClient && selectedVendor) {
			return 
		}
		keywordSearch(page);
	}, [page]);

	useEffect(() => {
		if (pageSize) {
			if (selectedCategory && selectedClient && selectedVendor) {
				applySearch(1)
			}
			else if (page == 1) {
				keywordSearch(1);
			} else {
				setpage(1);
			}
			
		}
	}, [pageSize]);

	useEffect(() => {
		setInvData(data);
		setpage(1);
	}, [data]);

	useEffect(() => {
		if (inv_data_hook.isSuccess && inv_data_hook.data) {
			setInvData(inv_data_hook.data?.contract);
			setCount(inv_data_hook.data?.count || inv_data_hook.data?.contract_count)
		}
	}, [inv_data_hook.isSuccess, inv_data_hook.data]);

	function getUniqueClients(
		lst,
		selectedVendor = null,
		selectedCategory = null
	) {
		const uniqueClients = [];
		const seenClientIds = new Set();

		lst
			?.filter((item) => {
				// If no vendor or category selected, include all
				if (!selectedVendor && !selectedCategory) return true;
				// If both vendor and category selected, match both
				if (selectedVendor && selectedCategory) {
					return (
						item.vendor_id === selectedVendor?.vendor_id &&
						item.category_id === selectedCategory?.category_id
					);
				}
				// If only vendor selected
				if (selectedVendor) {
					return item.vendor_id === selectedVendor?.vendor_id;
				}
				// If only category selected
				if (selectedCategory) {
					return item.category_id === selectedCategory?.category_id;
				}
				return true;
			})
			?.forEach((item) => {
				if (!seenClientIds.has(item.client_id)) {
					seenClientIds.add(item.client_id);
					uniqueClients.push({
						client_id: item.client_id,
						client: item.client,
					});
				}
			});

		return sortDropdownOptions(uniqueClients, (o) => o.client);
	}

	function getUniqueVendors(
		lst,
		selectedClient = null,
		selectedCategory = null
	) {
		const uniqueVendors = [];
		const seenVendorIds = new Set();

		lst
			?.filter((item) => {
				// If no vendor or category selected, include all
				if (!selectedClient && !selectedCategory) return true;
				// If both vendor and category selected, match both
				if (selectedClient && selectedCategory) {
					return (
						item.client_id === selectedClient?.client_id &&
						item.category_id === selectedCategory?.category_id
					);
				}
				// If only vendor selected
				if (selectedVendor) {
					return item.vendor_id === selectedVendor?.vendor_id;
				}
				// If only category selected
				if (selectedClient) {
					return item.client_id === selectedClient?.client_id;
				}
				return true;
			})
			?.forEach((item) => {
				if (!seenVendorIds.has(item.vendor_id)) {
					seenVendorIds.add(item.vendor_id);
					uniqueVendors.push({
						vendor_id: item.vendor_id,
						vendor: item.vendor,
					});
				}
			});

		return sortDropdownOptions(uniqueVendors, (o) => o.vendor);
	}

	function getUniqueCategories(
		lst,
		selectedVendor = null,
		selectedClient = null
	) {
		const uniqueCategories = [];
		const seenCategoryIds = new Set();

		lst
			?.filter((item) => {
				// If no vendor or category selected, include all
				if (!selectedClient && !selectedVendor) return true;
				// If both vendor and category selected, match both
				if (selectedClient && selectedVendor) {
					return (
						item.client_id === selectedClient?.client_id &&
						item.vendor_id === selectedVendor?.vendor_id
					);
				}
				// If only vendor selected
				if (selectedVendor) {
					return item.vendor_id === selectedVendor?.vendor_id;
				}
				// If only category selected
				if (selectedClient) {
					return item.client_id === selectedClient?.client_id;
				}
				return true;
			})
			?.forEach((item) => {
				if (!seenCategoryIds.has(item.category_id)) {
					seenCategoryIds.add(item.category_id);
					uniqueCategories.push({
						category_id: item.category_id,
						category_name: item.category_name,
					});
				}
			});

		return sortDropdownOptions(uniqueCategories, (o) => o.category_name);
	}

	const uniqueClients = useMemo(
		() => getUniqueClients(Filters, selectedVendor, selectedCategory),
		[Filters, selectedClient, selectedVendor, selectedCategory]
	);
	const uniqueVendors = useMemo(
		() => getUniqueVendors(Filters, selectedClient, selectedCategory),
		[Filters, selectedClient, selectedVendor, selectedCategory]
	);
	const uniqueCategories = useMemo(
		() => getUniqueCategories(Filters, selectedVendor, selectedClient),
		[Filters, selectedClient, selectedVendor, selectedCategory]
	);

	const [selectedContract, setSelectedContract] = useState(null);
    const [selectedStartDate, setSelectedStartDate] = useState(new Set())
    const [selectedEndDate, setSelectedEndDate] = useState(new Set())
	const [selectedUploadedAt, setSelectedUploadedAt] = useState(new Set());
	const [selectedUploadedBy, setSelectedUploadedBy] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedPromisee, setSelectedPromisee] = useState(null);
	const [selectedUpdatedAt, setSelectedUpdatedAt] = useState(new Set());

	const filterChangeDetected = useRef(false);

	function clearAllFilters() {
		setSelectedVendor('');
		setSelectedCategory('');
		setSelectedClient('');

		setSelectedContract(null);
		setSelectedUploadedAt(new Set());
		setSelectedUploadedBy(null);
		setSelectedUpdatedAt(new Set());
		setSelectedStatus(null);
        setSelectedPromisee(null)
        setSelectedStartDate(new Set())
        setSelectedEndDate(new Set())
		setInvData([]);

		if (page !== 1) {
			setpage(1);
		}
		else{
			keywordSearch(1);
		}
	}

	function getUniqueValues(lst, key, filters) {
		const uniqueValues = [];
		const seenIds = new Set();

		lst
			.filter((itm) => itm[key])
			.filter((itm) => {
				return filters.every((filter) => {
					if (
						filter.key === 'updated_at' ||
						filter.key === 'uploaded_at' ||
                        filter.key === 'start_date' || 
                        filter.key === 'end_date' 
					) {
						return (
							filter.value?.size == 0 ||
							[...filter.value]?.some((vl) =>
								dayjs(itm[filter.key])?.isSame(dayjs(vl), 'day')
							)
						);
					} else {
						if (!filter.value) {
							return true;
						}
						else if (
							filter.key === 'uploaded_by'
						) {
							return itm[filter.key] === filter.value._id;
						}
						else if (
							filter.key === 'fname'
						) {
							return itm['_id'] === filter.value._id;
						}
                        else{
                            return itm[filter.key] === filter.value;
                        }
					}
				});
			}).forEach((item) => {
				if (!seenIds.has(item[key])) {
					seenIds.add(item[key]);
					if (key === 'fname') {
						uniqueValues.push({
							_id: item._id,
							contract_name: item[key],
						});
					} else if (key === 'uploaded_by') {
						uniqueValues.push({
							_id: item.uploaded_by,
							uploaded_by: item['uploaded_by_name'],
						});
					} else {
						uniqueValues.push(item[key]);
					}
				}
			});
		return sortDropdownOptions(uniqueValues, (item) => {
			if (item && typeof item === 'object') {
				return item.contract_name ?? item.uploaded_by ?? '';
			}
			return item;
		});
	}

	const uniqueContracts = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'fname',
				[
					{ key: 'uploaded_at', value: selectedUploadedAt },
					{ key: 'uploaded_by', value: selectedUploadedBy },
                    { key: 'updated_at', value: selectedUpdatedAt },
                    { key: 'start_date', value: selectedStartDate },
                    { key: 'end_date', value: selectedEndDate },
                    { key: 'disp_status', value: selectedStatus },
                    { key: 'promisee', value: selectedPromisee },
				]
				
			),
		[
			childFilters,
            selectedUploadedAt,
            selectedUploadedBy,
            selectedUpdatedAt,
            selectedStartDate,
            selectedEndDate,
            selectedStatus,
            selectedPromisee
		]
	);

	const uniqueUploadedAt = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'uploaded_at',
				[
					{ key: 'fname', value: selectedContract },
					{ key: 'uploaded_by', value: selectedUploadedBy },
                    { key: 'updated_at', value: selectedUpdatedAt },
                    { key: 'start_date', value: selectedStartDate },
                    { key: 'end_date', value: selectedEndDate },
                    { key: 'disp_status', value: selectedStatus },
                    { key: 'promisee', value: selectedPromisee },
				]
				
			),
		[
			childFilters,
            selectedContract,
            selectedUploadedBy,
            selectedUpdatedAt,
            selectedStartDate,
            selectedEndDate,
            selectedStatus,
            selectedPromisee
		]
	);

	const uniqueUploadedBy = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'uploaded_by',
				[
					{ key: 'fname', value: selectedContract },
					{ key: 'uploaded_at', value: selectedUploadedAt },
                    { key: 'updated_at', value: selectedUpdatedAt },
                    { key: 'start_date', value: selectedStartDate },
                    { key: 'end_date', value: selectedEndDate },
                    { key: 'disp_status', value: selectedStatus },
                    { key: 'promisee', value: selectedPromisee },
				]
				
			),
		[
			childFilters,
            selectedContract,
            selectedUploadedAt,
            selectedUpdatedAt,
            selectedStartDate,
            selectedEndDate,
            selectedStatus,
            selectedPromisee
		]
	);

    const uniqueUpdatedAt = useMemo(
        () =>
            getUniqueValues(
                childFilters,
                'updated_at',
                [
                    { key: 'fname', value: selectedContract },
                    { key: 'uploaded_at', value: selectedUploadedAt },
                    { key: 'uploaded_by', value: selectedUploadedBy },
                    { key: 'start_date', value: selectedStartDate },
                    { key: 'end_date', value: selectedEndDate },
                    { key: 'disp_status', value: selectedStatus },
                    { key: 'promisee', value: selectedPromisee },
                ]
                
            ),
        [
            childFilters,
            selectedContract,
            selectedUploadedAt,
            selectedUploadedBy,
            selectedStartDate,
            selectedEndDate,
            selectedStatus,
            selectedPromisee
        ]
    );

    const uniqueStartDate = useMemo(
        () =>
            getUniqueValues(
                childFilters,
                'start_date',
                [
                    { key: 'fname', value: selectedContract },
                    { key: 'updated_at', value: selectedUpdatedAt },
                    { key: 'uploaded_at', value: selectedUploadedAt },
                    { key: 'uploaded_by', value: selectedUploadedBy },
                    { key: 'end_date', value: selectedEndDate },
                    { key: 'disp_status', value: selectedStatus },
                    { key: 'promisee', value: selectedPromisee },
                ]
                
            ),
        [
            childFilters,
            selectedContract,
            selectedUploadedAt,
            selectedUploadedBy,
            selectedUpdatedAt,
            selectedEndDate,
            selectedStatus,
            selectedPromisee
        ]
    );

    const uniqueEndDate = useMemo(
        () =>
            getUniqueValues(
                childFilters,
                'end_date',
                [
                    { key: 'fname', value: selectedContract },
                    { key: 'updated_at', value: selectedUpdatedAt },
                    { key: 'uploaded_at', value: selectedUploadedAt },
                    { key: 'uploaded_by', value: selectedUploadedBy },
                    { key: 'start_date', value: selectedStartDate },
                    { key: 'disp_status', value: selectedStatus },
                    { key: 'promisee', value: selectedPromisee },
                ]
                
            ),
        [
            childFilters,
            selectedContract,
            selectedUploadedAt,
            selectedUploadedBy,
            selectedUpdatedAt,
            selectedStartDate,
            selectedStatus,
            selectedPromisee
        ]
    );

    const uniqueStatus = useMemo(
        () =>
            getUniqueValues(
                childFilters,
                'disp_status',
                [
                    { key: 'fname', value: selectedContract },
                    { key: 'updated_at', value: selectedUpdatedAt },
                    { key: 'uploaded_at', value: selectedUploadedAt },
                    { key: 'uploaded_by', value: selectedUploadedBy },
                    { key: 'start_date', value: selectedStartDate },
                    { key: 'end_date', value: selectedEndDate },
                    { key: 'promisee', value: selectedPromisee },
                ]
                
            ),
        [
            childFilters,
            selectedContract,
            selectedUploadedAt,
            selectedUploadedBy,
            selectedUpdatedAt,
            selectedStartDate,
            selectedEndDate,
            selectedPromisee
        ]
    );

        const uniquePromisess = useMemo(
        () =>
            getUniqueValues(
                childFilters,
                'promisee',
                [
                    { key: 'fname', value: selectedContract },
                    { key: 'updated_at', value: selectedUpdatedAt },
                    { key: 'uploaded_at', value: selectedUploadedAt },
                    { key: 'uploaded_by', value: selectedUploadedBy },
                    { key: 'start_date', value: selectedStartDate },
                    { key: 'end_date', value: selectedEndDate },
                    { key: 'disp_status', value: selectedStatus },
                ]
                
            ),
        [
            childFilters,
            selectedContract,
            selectedUploadedAt,
            selectedUploadedBy,
            selectedUpdatedAt,
            selectedStartDate,
            selectedEndDate,
            selectedStatus
        ]
    );

    
    useEffect(() => {
    if (selectedCategory && selectedClient && selectedVendor) {
			const bd = {
				client_id: selectedClient.client_id,
				vendor_id: selectedVendor.vendor_id,
				category_id: selectedCategory.category_id,
			};
			setChildFilters([]);
			setContractFilters([]);
			getChildFiltersHook.mutate(bd);
		}
	}, [selectedCategory, selectedClient, selectedVendor]);

	useEffect(() => {
		if (getChildFiltersHook.isSuccess && getChildFiltersHook.data) {
			setChildFilters(getChildFiltersHook.data?.data);
		}
	}, [getChildFiltersHook.isSuccess, getChildFiltersHook.data]);


	async function applySearch(page = 1) {
		let body = {
			contract_limit: pageSize,
			contract_page: page,
			client_id: selectedClient?.client_id,
			vendor_id: selectedVendor?.vendor_id,
			category_id: selectedCategory?.category_id,
			contract_name: selectedContract?.contract_name || null,
			uploaded_by: selectedUploadedBy?._id || null,
            disp_status: selectedStatus || null 
		};

		if (selectedUploadedAt.size > 0) {
			body['uploaded_at'] = [...selectedUploadedAt].map((date) =>
				dayjs(date).format('MM-DD-YYYY')
			);
		}
		if (selectedUpdatedAt.size > 0) {
			body['updated_at'] = [...selectedUpdatedAt].map((date) =>
				dayjs(date).format('MM-DD-YYYY')
			);
		}
        if (selectedStartDate.size > 0) {
			body['start_date'] = [...selectedStartDate].map((date) =>
				dayjs(date).format('MM-DD-YYYY')
			);
		}
        if (selectedEndDate.size > 0) {
			body['end_date'] = [...selectedEndDate].map((date) =>
				dayjs(date).format('MM-DD-YYYY')
			);
		}
		setInvData([]);
		searchContractListHook.mutate(body);
	}

	useEffect(() => {
		if (searchContractListHook.isSuccess && searchContractListHook.data) {
			setInvData(searchContractListHook.data?.data);
			setCount(searchContractListHook.data?.contract_count || searchContractListHook.data?.count);
		}
	}, [searchContractListHook.isSuccess, searchContractListHook.data]);

	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return; // Skip applySearch on first render
		}
		if (selectedCategory && selectedClient && selectedVendor ) {
			applySearch(page);
		}
	}, [page]);

	useEffect(() => {
		if (pageSize) {
			if (selectedCategory && selectedClient && selectedVendor) {
				applySearch(1)
			}
			else if (page == 1) {
				keywordSearch(1);
			} else {
				setpage(1);
			}
			
		}
	}, [pageSize]);

	useEffect(() => {
		filterChangeDetected.current = true;
	}, [
		selectedClient,
		selectedVendor,
		selectedCategory,
		selectedContract,
		selectedContract,
		selectedUploadedAt,
		selectedUploadedBy,
		selectedUpdatedAt,
	]);

		function handleNavigate(obj) {
			const params = createSearchParams({ 
			client_id: obj?.client_id,
			client_name: obj?.client,
			client_list_page_no: 1,
			client_list_sort_key: '',
			client_list_sort_order: '',

			vendor_id: obj?.vendor_id,
			vendor_name: obj?.vendor,
			vendor_list_page_no : 1,
			vendor_list_sort_key: '',
			vendor_list_sort_order: '',
			category_name: obj?.category_name,
			category_id: obj?.category_id,

			contract_id: obj._id,
			contract_name: obj.fname,
			contract_list_page_no : 1,
			contract_list_sort_key: '',
			contract_list_sort_order: '',
		}).toString();

		window.open(`/my-contract-details?${params}`, '_blank'); // 
					
		}
	
	useEffect(() => {
		// Define an async function inside useEffect
		const fetchPageSize = async () => {
			try {
				const page_size = await getpageSizeCall();
				console.log(page_size, 'pg in client');
				setPageSize(page_size); // Set the page size state
			} catch (error) {
				console.error('Error fetching page size:', error);
			}
		};

		fetchPageSize(); // Call the async function
	}, []); //

	const handlePageSizeChange = async (event) => {
		const selectedPageSize = event.target.value;
		setPageSize(null);
		let ret = await setpageSizeCall(selectedPageSize);
		try {
			const page_size = await getpageSizeCall();
			console.log(page_size, 'pg in client');
			setPageSize(page_size); // Set the page size state
		} catch (error) {
			console.error('Error fetching page size:', error);
		}
	};	


	return (
		<div className="border pt-5 px-4 pb-0 rounded-lg mt-8 relative">
			<label className="absolute -top-6 left-4 font-black text-primary text-lg px-1 py-2 bg-white">
				Contracts
			</label>
			<div className=" p-6">
				<div className="flex w-full gap-4 items-center">
					{/* Search Bar */}
					<div className="grow relative flex items-center gap-4">
						<div className="w-full sm:w-[48%] lg:w-[23.5%]">
							<Autocomplete
								id="client"
								options={uniqueClients}
								getOptionLabel={(option) =>
									typeof option === 'string' ? option : option.client
								}
								isOptionEqualToValue={(option, value) =>
									option.client_id === value.client_id
								}
								value={selectedClient}
								onChange={(event, newValue) => {
									setSelectedClient(newValue);
								}}
								loading={getfilterHook.isFetching}
								loadingText="Loading..."
								renderInput={(params) => (
									<TextField {...params} label="Clients" fullWidth />
								)}
								renderOption={(props, option) => (
									<li {...props} key={option['client_id']} >
										{option['client']}
									</li>
								)}
							/>
						</div>

						<div className="w-full sm:w-[48%] lg:w-[23.5%]">
							<Autocomplete
								id="vendor"
								options={uniqueVendors}
								getOptionLabel={(option) =>
									typeof option === 'string' ? option : option.vendor
								}
								isOptionEqualToValue={(option, value) =>
									option.vendor_id === value.vendor_id
								}
								value={selectedVendor}
								onChange={(event, newValue) => {
									setSelectedVendor(newValue);
								}}
								loading={getfilterHook.isFetching}
								loadingText="Loading..."
								renderInput={(params) => (
									<TextField {...params} label="Vendors" fullWidth />
								)}
								renderOption={(props, option) => (
									<li {...props} key={option['vendor_id']} >
										{option['vendor']}
									</li>
								)}
							/>
						</div>

						<div className="w-full sm:w-[48%] lg:w-[23.5%]">
							<Autocomplete
								id="category"
								options={uniqueCategories}
								getOptionLabel={(option) =>
									typeof option === 'string' ? option : option.category_name
								}
								isOptionEqualToValue={(option, value) =>
									option.category_id === value.category_id
								}
								value={selectedCategory}
								onChange={(event, newValue) => {
									setSelectedCategory(newValue);
								}}
								loading={getfilterHook.isFetching}
								loadingText="Loading..."
								renderInput={(params) => (
									<TextField {...params} label="Categories" fullWidth />
								)}
								renderOption={(props, option) => (
									<li {...props} key={option['category_id']}>
										{option['category_name']}
									</li>
								)}
							/>
						</div>

						{selectedCategory && selectedClient && selectedVendor && (
							<>
								<div className="flex justify-end gap-4">
									<button
										className="bg-blue-500 text-white px-4 py-2 rounded-md disabled:bg-gray-300 disabled:cursor-not-allowed"
										onClick={() => {
											clearAllFilters();
										}}
									>
										Clear All
									</button>

									<button
										className="bg-blue-500 text-white px-4 py-2 rounded-md disabled:bg-gray-300 disabled:cursor-not-allowed"
										disabled={searchContractListHook.isPending}
										onClick={() => {
											if (filterChangeDetected.current === true) {
												if (page === 1) {
													applySearch(1);
												} else {
													setpage(1);
												}
											} else {
												applySearch(page);
											}
											filterChangeDetected.current = false;
										}}
									>
										Apply Filters
									</button>
								</div>
							</>
						)}
					</div>
				</div>
			</div>

			{selectedCategory && selectedClient && selectedVendor && (
				<div className="border-t p-6 text-xs gListFilters">
					<div className="flex w-full gap-4 items-center">
						{/* Search Bar */}
						<div className="grow relative flex items-center gap-4">
							

							

							<div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<Autocomplete
									id="contract_name"
									options={uniqueContracts}
									getOptionLabel={(option) => option.contract_name}
									isOptionEqualToValue={(option, value) =>
										option._id === value._id
									}
									value={selectedContract}
									onChange={(event, newValue) => setSelectedContract(newValue)}
									loading={getChildFiltersHook.isPending}
									loadingText="Loading..."
									renderInput={(params) => (
										<TextField {...params} label="Contracts" fullWidth />
									)}
									renderOption={(props, option) => (
										<li {...props} key={option._id} >
											{option.contract_name}
										</li>
									)}
								/>
							</div>

                            <div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<Autocomplete
									id="disp_status"
									options={uniqueStatus}
									getOptionLabel={(option) => option}
									isOptionEqualToValue={(option, value) =>
										option === value
									}
									value={selectedStatus}
									onChange={(event, newValue) => setSelectedStatus(newValue)}
									loading={getChildFiltersHook.isPending}
									loadingText="Loading..."
									renderInput={(params) => (
										<TextField {...params} label="Status" fullWidth />
									)}
									renderOption={(props, option) => (
										<li {...props} key={option} >
											{option}
										</li>
									)}
								/>
							</div>

                            <div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<Autocomplete
									id="promisee"
									options={uniquePromisess}
									getOptionLabel={(option) => option}
									isOptionEqualToValue={(option, value) =>
										option === value
									}
									value={selectedPromisee}
									onChange={(event, newValue) => setSelectedPromisee(newValue)}
									loading={getChildFiltersHook.isPending}
									loadingText="Loading..."
									renderInput={(params) => (
										<TextField {...params} label="Promisee" fullWidth />
									)}
									renderOption={(props, option) => (
										<li {...props} key={option} >
											{option}
										</li>
									)}
								/>
							</div>

                            <div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<DatePickerButton
									dates={uniqueStartDate}
									selectedDates={selectedStartDate}
									setSelectedDates={setSelectedStartDate}
									name={'Start Date'}
								/>
							</div>

                            <div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<DatePickerButton
									dates={uniqueEndDate}
									selectedDates={selectedEndDate}
									setSelectedDates={setSelectedEndDate}
									name={'End Date'}
								/>
							</div>


							<div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<DatePickerButton
									dates={uniqueUploadedAt}
									selectedDates={selectedUploadedAt}
									setSelectedDates={setSelectedUploadedAt}
									name={'Uploaded Date'}
								/>
							</div>

                            <div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<DatePickerButton
									dates={uniqueUpdatedAt}
									selectedDates={selectedUpdatedAt}
									setSelectedDates={setSelectedUpdatedAt}
									name={'Updated Date'}
								/>
							</div>

							<div className="w-full sm:w-[48%] lg:w-[23.5%]">
								<Autocomplete
									id="uploaded_by"
									options={uniqueUploadedBy}
									getOptionLabel={(option) => option['uploaded_by']}
									isOptionEqualToValue={(option, value) =>
										option._id === value._id
									}
									value={selectedUploadedBy}
									onChange={(event, newValue) =>
										setSelectedUploadedBy(newValue)
									}
									loading={getChildFiltersHook.isPending}
									loadingText="Loading..."
									renderInput={(params) => (
										<TextField {...params} label="Uploaded By" fullWidth />
									)}
									renderOption={(props, option) => (
										<li {...props} key={option._id}>
											{option['uploaded_by']}
										</li>
									)}
								/>
							</div>

							
						</div>
					</div>
				</div>
			)}

			<div className="listDHeight larger overflow-auto">
				{/* Table body head */}
				{invData?.length > 0 && (
					<div className="flex gap-2 mb-2">
						<div className="grow px-5 py-1 text-xs flex items-center justify-between">
							<div className="flex-none w-[140px] pr-4">
								<label
									className={`font-black block w-[140px] relative cursor-pointer`}
								>
									Name of Document
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Client
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Category
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[155px]">
								<label className={`font-black block relative cursor-pointer`}>
									Project Type
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[155px]">
								<label className={`font-black block relative cursor-pointer`}>
									Vendor
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[155px]">
								<label className={`font-black block relative cursor-pointer`}>
									Uploaded By
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Start Date
								</label>
							</div>
                            <div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									End Date
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Uploaded Date
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Updated Date
								</label>
							</div>		
						</div>
						<div className="opacity-0 flex-none px-4 text-xs text-center w-[106px]">
								&nbsp;
						</div>
					</div>
				)}
				{/* Table body Row */}
				{!searchContractListHook.isPending && !inv_data_hook.isPending && invData?.length == 0 && (
					<div class="flex items-center justify-center h-12">
						<p class="text-gray-500 text-lg font-medium">No data found</p>
					</div>
				)}
				{/* {['', null].includes(searchParams.get('keyword')) && (
					<div class="flex items-center justify-center h-12">
						<p class="text-gray-500 text-lg font-medium">No text searched</p>
					</div>
				)} */}
				{searchContractListHook.isPending || inv_data_hook.isPending ? (
					<LoaderFull />
				) : (
					invData?.map((obj, index) => {
						return (
							<div className="flex gap-2 mb-2 tblLoop">
								<div className="grow border rounded-md px-5 py-3 text-sm flex items-center justify-between">
									<div className="flex-none w-[140px] relative flex border-r pr-4 items-center">
										<span
											title={obj?.fname}
											className="absolute w-full block truncate"
										>
											{obj?.fname ? (
												<TextHighlighter
													text={obj.fname}
													searchString={searchParams.get('keyword')}
												/>
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span
											title={obj?.client}
											className="absolute w-full block truncate"
										>
											{obj?.client ? (
												<TextHighlighter
													text={obj.client}
													searchString={searchParams.get('keyword')}
												/>
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span
											title={obj?.category_name}
											className="absolute w-full block truncate"
										>
											{obj?.category_name ? (
												<TextHighlighter
													text={obj.category_name}
													searchString={searchParams.get('keyword')}
												/>
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.project_type}
											className="absolute w-full block truncate"
										>
											{obj?.project_type ? (
												<TextHighlighter
													text={obj.project_type}
													searchString={searchParams.get('keyword')}
												/>
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.vendor}
											className="absolute w-full block truncate"
										>
											{obj?.vendor ? (
												<TextHighlighter
													text={obj.vendor}
													searchString={searchParams.get('keyword')}
												/>
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.uploaded_by}
											className="absolute w-full block truncate"
										>
											{obj?.uploaded_by || (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none border-r px-4 text-center w-[140px]">
										<TimeZoneConverter utcTimestamp={obj.start_date} />
									</div>
                                    <div className="flex-none border-r px-4 text-center w-[140px]">
										<TimeZoneConverter utcTimestamp={obj.end_date} />
									</div>
									<div className="flex-none border-r px-4 text-center w-[140px]">
										<TimeZoneConverter utcTimestamp={obj.uploaded_at} />
									</div>
									<div className="flex-none px-4 text-center w-[140px]">
										<TimeZoneConverter utcTimestamp={obj.updated_at} />
									</div>									
								</div>
								<div className="flex-none flex w-[106px] pr-2">
										<button
											disabled={obj?.percentage_complete<100}
											onClick={() => handleNavigate(obj)}
											type="button"
											title={obj?.percentage_complete<100 ? 'Processing Contract' : ''}
											className="vLBG block px-0 py-3 w-full text-center text-primary text-sm rounded-md font-black mx-1 disabled:bg-gray-200 disabled:text-gray-500"
										>
											{obj?.csv_upload ? 'View CSV' : 'View' }
										</button>
									</div>
							</div>
						);
					})
				)}
			</div>
			<div className="flex justify-center py-2">
				{invData && (
					<>
						<div className="flex items-center justify-between space-x-4">
							{/* Pagination Component */}
							<div className="flex items-center space-x-2">
								{/* <p>Rows per page</p> */}
								{pageSize ? (
									<FormControl
											variant="outlined"
											size="small"
											sx={{
												minWidth: 120,
												'& .MuiOutlinedInput-root': {
												borderRadius: '0.375rem', // rounded-md
												backgroundColor: 'white',
												fontSize: '0.875rem', // text-sm
												},
												'& .MuiOutlinedInput-notchedOutline': {
												borderColor: '#D1D5DB', // border-gray-300
												},
												'&:hover .MuiOutlinedInput-notchedOutline': {
												borderColor: '#60A5FA', // blue-400 on hover
												},
												'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
												borderColor: '#3B82F6', // focus:ring-blue-500
												borderWidth: '2px',
												},
											}}
											>
											<InputLabel id="page-size-label">Page Size</InputLabel>
											<Select
												labelId="page-size-label"
												value={pageSize || ''}
												onChange={handlePageSizeChange}
												label="Page Size"
											>
												{PAGE_SIZE_OPTIONS.map((size) => (
												<MenuItem key={size} value={size}>
													{size}
												</MenuItem>
												))}
											</Select>
											</FormControl>
								) : (
									<div className="w-[60px] h-[40px] flex justify-center items-center bg-gray-100 rounded-md text-sm text-center border border-gray-300">
										<span className="material-icons text-sm animate-spin">
											autorenew
										</span>{' '}
										{/* Spinner */}
									</div>
								)}
							</div>
						<Pagination
							page={page}
							onChange={(e, value) => {
								setpage(value);
							}}
							count={Math.ceil(Count / (pageSize || 20))}
							color="primary"
							variant="outlined"
							shape="rounded"
						/>
					</div>
					</>

				)}
			</div>
		</div>
	);
};
